'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _rollupPluginBabelHelpers = require('../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var styles = require('@material-ui/core/styles');
var MuiCheckbox = require('@material-ui/core/Checkbox');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var MuiCheckbox__default = /*#__PURE__*/_interopDefaultLegacy(MuiCheckbox);

var CheckboxIcon = styles.experimentalStyled('span')({
  borderRadius: 3,
  width: 16,
  height: 16,
  minWidth: 16,
  maxHeight: 16,
  boxShadow: 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: '#f5f8fa',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2
  },
  'input:hover ~ &': {
    backgroundColor: '#ebf1f5'
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background: 'rgba(206,217,224,.5)'
  }
});
var CheckboxCheckedIcon = styles.experimentalStyled(CheckboxIcon)(_ref => {
  var {
    theme
  } = _ref;
  return {
    // animation: 'checkbox-bounce 75ms 1',
    backgroundColor: theme.palette.secondary.main,
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" + " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " + "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""'
    },
    'input:hover ~ &': {
      backgroundColor: styles.darken(theme.palette.secondary.main, 0.05)
    }
  };
});
function Checkbox(props) {
  return /*#__PURE__*/React__namespace.createElement(MuiCheckbox__default['default'], _rollupPluginBabelHelpers['extends']({
    sx: {
      '&:hover': {
        bgcolor: 'transparent'
      }
    },
    disableRipple: true,
    color: "default",
    checkedIcon: /*#__PURE__*/React__namespace.createElement(CheckboxCheckedIcon, null),
    icon: /*#__PURE__*/React__namespace.createElement(CheckboxIcon, null)
  }, props));
}

exports.Checkbox = Checkbox;
exports.default = Checkbox;
